

export const setOnboardingFormValue = async (store, stepSlug, val) => {
    const onboarding = {
        ...store.state.onboarding,
        formValues: store.state.onboarding.formValues.map(field => 
            field.name === stepSlug ? {
                name: stepSlug,
                value: val
            } : field)
    };
    store.setState({ onboarding });
};

export const nextStep = async (store, section='basic') => {
    console.log('GO TO NEXT STEP', section);
    let currentStep = store.state.onboarding.current_step;
    let stepIndex = -1;
    const onboarding = {
        ...store.state.onboarding 
    }
    if(section === 'basic') {
        stepIndex = store.state.onboarding.steps.basic.map(function(s) { return s.slug; }).indexOf(currentStep);
        console.log('CURRENT STEP', currentStep, stepIndex);
        if((stepIndex+1) >= store.state.onboarding.steps.basic.length) {
            onboarding.basic_complete = true;
            currentStep = store.state.onboarding.steps.business[0].slug;
        } else {
            currentStep = store.state.onboarding.steps.basic[stepIndex + 1].slug || null;
        }
    } else {
        stepIndex = store.state.onboarding.steps.business.map(function(s) { return s.slug; }).indexOf(currentStep);
        if((stepIndex+1) < store.state.onboarding.steps.business.length) {
            currentStep = store.state.onboarding.steps.business[stepIndex + 1].slug || null;
        } else {
            onboarding.business_complete = true;
            currentStep = '';
        }
    }
    console.log('NEXT STEP -- ', currentStep);

    onboarding.current_step = currentStep;
    store.setState({ onboarding });
}